import React from 'react';

/** Rende il testo dell'AI: grassetti **così**, elenchi con "- " e righe vuote. */
export const TestoAi = ({ testo, className = '' }) => {
  const righe = String(testo || '').split('\n');
  return (
    <div className={`space-y-1.5 ${className}`}>
      {righe.map((riga, i) => {
        const pulita = riga.trim();
        if (!pulita) return <div key={i} className="h-1" />;
        const elenco = pulita.startsWith('- ') || pulita.startsWith('• ');
        const testoRiga = elenco ? pulita.slice(2) : pulita;
        const intestazione = /^[A-Z À-Ú&']{4,40}$/.test(pulita);
        const pezzi = testoRiga.split(/\*\*(.+?)\*\*/g);
        const contenuto = pezzi.map((p, j) =>
          j % 2 === 1 ? <strong key={j} className="font-semibold">{p}</strong> : <span key={j}>{p}</span>
        );
        if (intestazione) {
          return (
            <p key={i} className="text-[11px] font-bold uppercase tracking-wide text-primary pt-1">
              {pulita}
            </p>
          );
        }
        return (
          <p key={i} className={`text-sm leading-relaxed ${elenco ? 'pl-4 relative' : ''}`}>
            {elenco && <span className="absolute left-0 text-primary">•</span>}
            {contenuto}
          </p>
        );
      })}
    </div>
  );
};

export default TestoAi;
